import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { ComponentsModule } from '../../../../../shared/ui-kit/components/components.module';
import { IconName } from '../../../../../shared/ui-kit/components/ui-icon-x/ui-icon-x.component';
import { LogoComponent } from '../../../../../shared/components/logo/logo.component';
import {XButtonComponent} from "../../../../../shared/x-kit/components/x-button/x-button.component";
import {Router} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-map-loader',
  standalone: true,
  imports: [NgIf, ComponentsModule, LogoComponent, XButtonComponent, TranslatePipe],
  templateUrl: './map-loader.component.html',
  styleUrl: './map-loader.component.less',
  animations: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapLoaderComponent {
  @Input() isShown: boolean = false;
  @Input() errorMessage: string = '';
  constructor(private router: Router) {}

  protected readonly IconName = IconName;

  goBack() {
    this.router.navigate(['auth']);
  }
}
